import React, { useState, useEffect } from "react";
import IPR from "./IPR";
// import { useLocation } from "react-router-dom";
import "./iprFrame.scss";
const IprFrame = ({
  iprData,
  chartValue,
  hideTeethParam,
  upperModelIndex,
  lowerModelIndex,
}) => {
  // const location = useLocation();
  const queryParams = new Map();

  const [upperAligners, setUpperAligners] = useState([]);
  const [lowerAligners, setLowerAligners] = useState([]);

  const sortAligners = (aligners) => {
    return aligners.sort((a, b) => a.aligner_count - b.aligner_count);
  };

  const dataMapper = (iprData) => {
    const upper = [];
    const lower = [];
    iprData.forEach((el) => {
      const mappedIprObject = {
        ...el,
        name: `aligner-${el.aligner_count}`,
        session: el.aligner_count,
        uniqueId: el.id,
      };
      if (el.jawType === "upper" && el.aligner_count === upperModelIndex) {
        upper.push(mappedIprObject);
      } 
      if (el.jawType === "lower" && el.aligner_count === lowerModelIndex){
        lower.push(mappedIprObject);
      }
    });
    return {
      lower: sortAligners(lower),
      upper: sortAligners(upper),
    };
  };

  const filterAttachmentsByAlignerCount = (data, excludeAlignerCounts) => {
    if (!Array.isArray(data) || !Array.isArray(excludeAlignerCounts)) {
      console.error("Invalid input: Both data and excludeAlignerCounts should be arrays.");
      return [];
    }
    return data.filter((item) => !excludeAlignerCounts.includes(item.aligner_count));
  };

  useEffect(() => {
    if (iprData) {
      // console.log("iprData:", iprData);
      const excludeAlignerCountsParam = queryParams.get("alignerCounts");
      const excludeAlignerCounts = excludeAlignerCountsParam
        ? excludeAlignerCountsParam.split(",").map(Number)
        : [];
      // console.log("excludeAlignerCountsexcludeAlignerCounts", excludeAlignerCounts)
      const filteredData = filterAttachmentsByAlignerCount(iprData, excludeAlignerCounts);
      // console.log("Filtered Data:", filteredData);

      const { lower, upper } = dataMapper(filteredData);
      const lData = lower.length > 1 ? lower[lowerModelIndex - 1] : lower[0];
      const uData = upper.length > 1 ? upper[upperModelIndex - 1] : upper[0];
      setLowerAligners([lData]);
      setUpperAligners([uData]);
    }
  }, [iprData, upperModelIndex, lowerModelIndex]);

  return (
    <div>
      <IPR
        chartValue={chartValue}
        lowerAligners={lowerAligners}
        upperAligners={upperAligners}
        hideTeethParam={hideTeethParam}
      />
    </div>
  );
};

export default IprFrame;
